@if (currentPage) {
  <div class="page-size-select mat-small">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-select [(value)]="pageSize"
        hideSingleSelectionIndicator
        (selectionChange)="onPageSizeChange($event)"
        required>
        <mat-option [value]="5">5</mat-option>
        <mat-option [value]="10">10</mat-option>
        <mat-option [value]="15">15</mat-option>
        <mat-option [value]="20">20</mat-option>
      </mat-select>
    </mat-form-field>
    items
  </div>
  <div class="items-on-page mat-small">
    pagina {{currentPage.getPageNumber()}}
  </div>
  <div class="buttons">
    <button mat-icon-button
      (click)="onPreviousClick()"
      [disabled]="currentPage.isFirstPage()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button
      (click)="onNextClick()"
      [disabled]="currentPage.isLastPage()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>
}
